<template>
	<div>
		<video-modal ref="videoModal" />
	</div>
</template>

<script>
import VideoModal from './VideoModal.vue'

export default {
	components: { VideoModal },
	props: {
	},
	mounted() {
		this.$logger('app/component/video-modal-listener/mounted');
		document.addEventListener('click', this.handleVideoModalClick);
	},
	unmounted() {
		document.removeEventListener('click', this.handleVideoModalClick);
	},	
	methods: {
		handleVideoModalClick(e) {
			
			var component = this;
			var url = e.target.href ?? null;
			var tagName = e.target.tagName ?? null;
			
			if (url && tagName == 'A' && e.target.href.includes('/video/')) {

				e.preventDefault(); 

				var segments = e.target.href.split('/');
				var entryId = segments[5];

				if(component.$refs.videoModal && entryId) {
					component.$logger('app/component/video-modal-listener/handle-video-modal-click/id:/' + entryId);
					component.$refs.videoModal.toggleModal();
					component.$refs.videoModal.loadVideo(entryId);				
				}
								
			}
		}
	}
};
</script>

<style>
</style>


